import React, { Component } from "react";
import PropTypes from "prop-types";

class RKPayRibbon extends Component {
	shouldComponentUpdate = ({ size }) => {
		const lastProps = this.props;

		return size !== lastProps.size;
	};

	render() {
		const { size } = this.props;

		return (
			<div
				className="rkpay-ribbon-wrapper"
				data-prevent-navigation
			>
				<img
					alt="RKPay"
					src={`/images/ribbon-${size}.png`}
					className="rkpay-ribbon"
				/>
			</div>
		);
	}
}

RKPayRibbon.propTypes = {
	size: PropTypes.oneOf(["sm", "md", "lg"]),
};

RKPayRibbon.defaultProps = {
	size: "sm",
};

export default RKPayRibbon;
